import React, { useEffect, useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import * as Icons from 'react-feather'
import AddFinancePartner from './AddFinancePartner'
import DeleteFinancePartner from './DeleteFinancePartner'
import ViewFinancePartner from './ViewFinancePartner'
import EditFinancePartner from './EditFinancePartner'
import FinancePartnerModel from './models/FinancePartnerModel'
import { logAuditEvent } from '../../utils/auditLogger'

function FinancePartnerModal({ onClose, onSubmit, UserAction, show, selectedRow, moduleName = 'Finance Partners' }) {
  const [childData, setChildData] = useState(new FinancePartnerModel() || [])
  const childDataRef = useRef(new FinancePartnerModel())
  let modalAction
  let showButtons
  let userAction = reactStringReplace(UserAction, 'User', () => '')

  useEffect(() => {
    if (show) {
      if (selectedRow) {
        const next = { ...selectedRow }
        childDataRef.current = next
        setChildData(next)
      } else {
        const next = new FinancePartnerModel()
        childDataRef.current = next
        setChildData(next)
      }
      return
    }
    const reset = new FinancePartnerModel()
    childDataRef.current = reset
    setChildData(reset)
  }, [selectedRow, show])

  const handleDataFromChild = (data) => {
    if (typeof data === 'function') {
      setChildData((prev) => {
        const next = data(prev ?? new FinancePartnerModel())
        childDataRef.current = next
        return next
      })
      return
    }
    const next = data ?? new FinancePartnerModel()
    childDataRef.current = next
    setChildData(next)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const actionDescriptor = UserAction === 'Delete' ? 'Delete Confirm' : 'Save'
    logAuditEvent(moduleName, `${UserAction || 'Action'} ${actionDescriptor}`, `${actionDescriptor} clicked`)
    onSubmit(e, childDataRef.current)
  }

  const handleCancel = (label) => {
    logAuditEvent(moduleName, `${UserAction || 'Action'} ${label}`, `${label} clicked`)
    onClose()
  }

  const handleLoad = (data) => {
    const next = data ?? new FinancePartnerModel()
    childDataRef.current = next
    setChildData(next)
  }

  if (UserAction === 'Add') {
    modalAction = <AddFinancePartner onLoad={handleLoad} sendDataToParent={handleDataFromChild} />
    showButtons = (
      <div>
        <button className="btn btn-cancel me-2" name="Add" onClick={() => handleCancel('Cancel')}>Cancel</button>
        <button className="btn btn-submit" name="Add" onClick={handleSubmit}> Submit </button>
      </div>
    )
  } else if (UserAction === 'Edit') {
    modalAction = <EditFinancePartner FinancePartnerData={childData} onSubmit={onSubmit} sendDataToParent={handleDataFromChild} />
    showButtons = (
      <div>
        <button className="btn btn-cancel me-2" name="Edit" onClick={() => handleCancel('Cancel')}>Cancel</button>
        <button className="btn btn-submit" name="Edit" onClick={handleSubmit}> Submit </button>
      </div>
    )
  } else if (UserAction === 'View') {
    modalAction = <ViewFinancePartner FinancePartnerData={selectedRow} />
    showButtons = (
      <div>
        <button className="btn btn-cancel me-2" name="View" onClick={() => handleCancel('Close')}>Cancel</button>
      </div>
    )
  } else if (UserAction === 'Delete') {
    modalAction = <DeleteFinancePartner FinancePartnerData={selectedRow} />
    showButtons = (
      <div>
        <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={() => handleCancel('Delete Cancel')}>Cancel</button>
        <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>Delete</button>
      </div>
    )
  }

  return (
    UserAction !== 'Delete'
      ? (
        <Modal show={show} onHide={() => handleCancel('Close')} backdrop="static">
          <ModalHeader className="modal-header border-0 custom-modal-header" closeButton>
            <ModalTitle>{userAction} Finance Partner</ModalTitle>
          </ModalHeader>
          <ModalBody>{modalAction}</ModalBody>
          <ModalFooter>{showButtons}</ModalFooter>
        </Modal>
      )
      : (
        <Modal show={show} onHide={() => handleCancel('Close')} backdrop="static">
          <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
            <ModalTitle>
              <div className="custom-alert-icon">
                <Icons.AlertOctagon className="flex-shrink-0" />
              </div>
              <div>{userAction} Finance Partner</div>
            </ModalTitle>
          </ModalHeader>
          <ModalBody>{modalAction}</ModalBody>
          <ModalFooter className="modalfooter-width">{showButtons}</ModalFooter>
        </Modal>
      )
  )
}

export default FinancePartnerModal
